import { AccountType } from "../UserDto";
import { DirectoryGroupsDto, DirectoryResultDto, DirectoryResultCode }
	from "UvExplorerServer.Dtos.TS/Auth";


export class GetDirectoryGroupsResultDto extends DirectoryResultDto {

	public Groups: DirectoryGroupsDto;

	constructor(code: DirectoryResultCode = DirectoryResultCode.None) {
		super(code);

		this.Groups = new DirectoryGroupsDto();
	}

	public get HasGroups(): boolean {
		return this.Groups.HasGroups;
	}

	public Write(obj: any, context: any): void {
		obj.get_directory_groups_result = {};
		obj = obj.get_directory_groups_result;

		super.Write(obj, context);

		if (this.HasGroups) {
			this.Groups.Write(obj, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_directory_groups_result)
			throw new Error();
		obj = obj.get_directory_groups_result;

		super.Read(obj, context);

		if (obj.directory_groups !== undefined) {
			this.Groups.Read(obj, context);
		}
	}

}